import React from "react";
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

export default function InputMaskWeight(props) {
  const { inputRef, unit = 'lbs', onChange, ...inputMaskProps } = props;
  const maskUnit = `999 ${unit}`;

  return (
    <InputMask
      {...inputMaskProps}
      inputRef={inputRef}
      onChange={(e) => {
        const enteredValue = e.target.value.trim();
        let updatedValue = enteredValue;
        if (!enteredValue || enteredValue === "lbs") {
          updatedValue = "";
        }
        props.onChange({
          target: {
            value: updatedValue,
          },
        });
      }}
      mask={maskUnit}
      maskChar=" "
      spellCheck={false}
    />
  );
}

InputMaskWeight.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/InputMaskWeight.js